module.exports = __webpack_public_path__ + "static/media/ccm_cover.34448dc8.png";